import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import DataService from 'lib/DataService';

import UserContext from 'contexts/User';
import UsersContext from 'contexts/Users';

import {
	Container,
	CloseButton,
} from './styles';

import List from './List';
import Brochures from './Brochures';
import Form from './Form';

const Api = new DataService();

class Collections extends React.Component {
	state = {
	  loading: true,
	  brochures: [],
	}

	componentWillReceiveProps(nextProps) {
	  if (this.props.collection !== nextProps.collection && nextProps.collection !== null) {
	    this.getBrochures(nextProps.collection);
	    return;
	  }

	  const collectionData = nextProps.collections.find(c => c.id === nextProps.collection);

	  if (collectionData && collectionData.brochures.length !== this.state.brochures.length) {
	    this.getBrochures(nextProps.collection);
	  }
	}

	getBrochures(id) {
	  this.setState({ loading: true });

	  Api.readCollectionBrochures(id)
	    .then(res => {
	      const { brochures } = res.result;

	      this.setState({
	        loading: false,
	        brochures,
	      });
	    });
	}

	componentDidMount() {
	  if (this.props.collection !== null) {
	    this.getBrochures(this.props.collection);
	  }
	}

	removeCollectionHandler = id => {
	  const { t } = this.props;

	  if (window.confirm(t('collection/Confirm remove'))) {
	    Api.deleteCollection(id)
	      .then(res => {
	        if (res.code === 200 && res.result.collection === true) {
	          this.props.removeCollectionHandler(id);
	        }
	      });
	  }
	}

	render() {
	  const { collection } = this.props;
	  const hasCollection = this.props.collections.some(c => c.id === collection);
	  const collectionData = hasCollection ? this.props.collections.find(c => c.id === collection) : false;

	  if (!collectionData && this.props.collections.length) {
	    this.props.collectionSelectHandler(this.props.collections[0].id);
	  }

	  return (
	    <UserContext.Consumer>
	      { user => (
	        <UsersContext.Consumer>
	          { users => (
	            <Container open={this.props.open}>
	              <CloseButton onClick={this.props.collectionOpenHandler}>Sulje kokoelma</CloseButton>
	              <List
	                collection={collection}
	                collections={this.props.collections}
	                collectionSelectHandler={this.props.collectionSelectHandler}
	                removeCollectionHandler={this.removeCollectionHandler}
	              />
	              <Brochures
	                loading={this.state.loading}
	                collection={collectionData}
	                brochures={this.state.brochures}
	                users={users}
	                baseUrl={this.props.config.baseUrl}
	                collectionHandler={this.props.collectionHandler}
	              />
	              <Form
	                collection={collectionData}
	                brochureCount={this.state.brochures.length}
	                baseUrl={this.props.config.baseUrl}
	                user={user}
	                collectionHandler={this.props.collectionHandler}
	              />
	            </Container>
	          )}
	        </UsersContext.Consumer>
	      )}
	    </UserContext.Consumer>
	  );
	}
}

Collections.propTypes = {
	t: PropTypes.func,
	config: PropTypes.object,
	open: PropTypes.bool,
	collection: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	collections: PropTypes.array,
	collectionSelectHandler: PropTypes.func,
	collectionHandler: PropTypes.func,
	removeCollectionHandler: PropTypes.func,
	collectionOpenHandler: PropTypes.func,
}

export default translate('translations')(Collections)
